<template>
  <div>
    <div
      class="kingster-page-title-wrap  kingster-style-medium kingster-center-align"
      :style="
        'background-image: url(' +
          require('@/assets/images/template4/page-title.jpg') +
          ')'
      "
    >
      <div class="kingster-header-transparent-substitute"></div>
      <div class="kingster-page-title-overlay"></div>
      <div class="kingster-page-title-container kingster-container">
        <div class="kingster-page-title-content kingster-item-pdlr">
          <div class="kingster-page-caption">{{ meta.name }}</div>
          <h1 class="kingster-page-title">Pengumuman</h1>
        </div>
      </div>
    </div>
    <div class="kingster-breadcrumbs">
      <div class="kingster-breadcrumbs-container kingster-container">
        <div class="kingster-breadcrumbs-item kingster-item-pdlr">
          <span property="itemListElement" typeof="ListItem"
            ><router-link
              :to="`/${meta.preview}`"
              property="item"
              typeof="WebPage"
              title="Go to Kingster."
              class="home"
              ><span property="name">Home</span></router-link
            >
            <meta property="position" content="1" /> </span
          >&gt;<span property="itemListElement" typeof="ListItem"
            ><span property="name"> Pengumuman </span>
            <meta property="position" content="2" />
          </span>
        </div>
      </div>
    </div>
    <div class="kingster-page-wrapper" id="kingster-page-wrapper">
      <div class="kingster-content-container kingster-container">
        <div
          class=" kingster-sidebar-wrap clearfix kingster-line-height-0 kingster-sidebar-style-both"
        >
          <!--  -->
          <div
            class=" kingster-sidebar-center kingster-column-30 kingster-line-height"
          >
            <div class="gdlr-core-page-builder-body">
              <div class="gdlr-core-pbf-section">
                <div
                  class="gdlr-core-pbf-section-container gdlr-core-container clearfix"
                >
                  <div class="gdlr-core-pbf-element">
                    <div
                      class="gdlr-core-blog-item gdlr-core-item-pdb clearfix  gdlr-core-style-blog-full"
                      style="padding-bottom: 40px ;"
                    >
                      <div
                        class="gdlr-core-blog-item-holder gdlr-core-js-2 clearfix"
                        data-layout="fitrows"
                      >
                        <div
                          class="gdlr-core-item-list gdlr-core-blog-full  gdlr-core-item-mglr gdlr-core-style-left"
                          v-for="(pengumuman, index) in news"
                          :key="`pengumuman_${index}`"
                          data-aos="fade-in"
                          :data-aos-duration="index + `000`"
                          :data-aos-delay="index + `00`"
                        >
                          <div
                            class="gdlr-core-blog-thumbnail gdlr-core-media-image  gdlr-core-opacity-on-hover gdlr-core-zoom-on-hover"
                          >
                            <a :href="`/pengumuman-detail/${pengumuman.url}`"
                              ><img
                                :src="
                                  pengumuman && pengumuman.image == null
                                    ? require('@/assets/images/template4/shutterstock_135948689-800x356.jpg')
                                    : pengumuman && pengumuman.image
                                "
                                class="img-fluid"
                                width="1100"
                                height="490"
                                alt=""
                            /></a>
                          </div>
                          <div class="gdlr-core-blog-full-head clearfix">
                            <div class="gdlr-core-blog-full-head-right">
                              <h3
                                class="gdlr-core-blog-title gdlr-core-skin-title"
                                style="font-size: 28px ;font-weight: 800 ;letter-spacing: 0px ;"
                              >
                                <a href="#">{{ pengumuman.title }}</a>
                              </h3>
                              <div
                                class="gdlr-core-blog-info-wrapper gdlr-core-skin-divider"
                              >
                                <span
                                  class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date"
                                  ><a href="#">{{
                                    pengumuman.published_at
                                  }}</a></span
                                ><span
                                  class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-author"
                                  ><span class="gdlr-core-head">By</span
                                  ><a
                                    href="#"
                                    title="Posts by John Smith"
                                    rel="author"
                                    >{{ pengumuman.author }}</a
                                  ></span
                                ><span
                                  class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-category"
                                  ><a href="#" rel="tag">{{
                                    pengumuman.type.name
                                  }}</a></span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="gdlr-core-blog-content">
                            <div v-html="pengumuman.body.slice(0, 400)"></div>
                            <div class="clear"></div>
                            <router-link
                              class="gdlr-core-excerpt-read-more gdlr-core-button gdlr-core-rectangle"
                              :to="`/pengumuman-detail/${pengumuman.url}`"
                              >Selengkapnya</router-link
                            >
                          </div>
                        </div>
                      </div>

                      <!--  -->
                      <div
                        class="gdlr-core-pagination  gdlr-core-style-circle gdlr-core-center-align gdlr-core-item-pdlr"
                      >
                        <a
                          :class="[currentPage === 1 ? 'btn-disabled' : '']"
                          class="prev page-numbers"
                          @click="goPage('prev')"
                        ></a>
                        <span
                          v-for="page in paging"
                          :key="page"
                          :class="[
                            currentPage === page || page === '...'
                              ? 'active btn-disabled'
                              : '',
                          ]"
                          aria-current="page"
                          @click="getData(page)"
                          class="page-numbers current"
                          >{{ page }}</span
                        >

                        <a
                          :class="[
                            currentPage === lastPage ? 'btn-disabled' : '',
                          ]"
                          class="next page-numbers"
                          @click="goPage('next')"
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--  -->
          <div
            class=" kingster-sidebar-left kingster-column-15 kingster-line-height kingster-line-height"
          >
            <div class="kingster-sidebar-area kingster-item-pdlr">
              <div id="text-6" class="widget widget_text kingster-widget">
                <h3 class="kingster-widget-title">Sejarah Kami</h3>
                <span class="clear"></span>
                <div
                  class="textwidget"
                  data-aos="fade-in"
                  data-aos-duration="3000"
                  data-aos-delay="300"
                  v-html="history.body"
                ></div>
              </div>
              <div
                id="recent-posts-3"
                class="widget widget_recent_entries kingster-widget"
              >
                <h3 class="kingster-widget-title">Pengumuman Terbaru</h3>
                <span class="clear"></span>
                <ul>
                  <li
                    v-for="(pengumuman, index) in news.slice(0, 7)"
                    :key="`pengumuman_${index}`"
                    data-aos="fade-in"
                    :data-aos-duration="index + `000`"
                    :data-aos-delay="index + `00`"
                  >
                    <a href="#">{{ pengumuman.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class=" kingster-sidebar-right kingster-column-15 kingster-line-height kingster-line-height"
          >
            <div class="kingster-sidebar-area kingster-item-pdlr">
              <div id="text-7" class="widget widget_text kingster-widget">
                <h3 class="kingster-widget-title">Tujuan Kami</h3>
                <span class="clear"></span>
                <div
                  class="textwidget"
                  v-html="purpose.body"
                  data-aos="fade-in"
                  data-aos-duration="3000"
                  data-aos-delay="300"
                ></div>
              </div>
              <div
                id="gdlr-core-recent-portfolio-widget-2"
                class="widget widget_gdlr-core-recent-portfolio-widget kingster-widget"
              >
                <h3 class="kingster-widget-title">Galeri</h3>
                <span class="clear"></span>
                <div class="gdlr-core-recent-portfolio-widget-wrap clearfix">
                  <div
                    class="gdlr-core-recent-portfolio-widget gdlr-core-media-image"
                    v-for="(galeri, index) in gallery.slice(0, 4)"
                    :key="`galeri_${index}`"
                    data-aos="fade-in"
                    :data-aos-duration="index + `000`"
                    :data-aos-delay="index + `00`"
                  >
                    <a href="#"
                      ><img
                        :src="galeri.image"
                        alt=""
                        width="150"
                        height="150"
                        title="shutterstock_53600224"/><span
                        class="gdlr-core-image-overlay "
                        ><i
                          class="gdlr-core-image-overlay-icon gdlr-core-size-15 icon_link_alt"
                        ></i></span
                    ></a>
                  </div>
                </div>
              </div>

              <div
                id="gdlr-core-recent-post-widget-2"
                class="widget widget_gdlr-core-recent-post-widget kingster-widget"
              >
                <h3 class="kingster-widget-title">Berita Terbaru</h3>
                <span class="clear"></span>
                <div
                  class="gdlr-core-recent-post-widget-wrap gdlr-core-style-2"
                >
                  <div
                    class="gdlr-core-recent-post-widget clearfix"
                    v-for="(dataBerita, index) in berita.slice(0, 4)"
                    :key="`berita_${index}`"
                    data-aos="fade-in"
                    :data-aos-duration="index + `000`"
                    :data-aos-delay="index + `00`"
                  >
                    <div class="gdlr-core-recent-post-widget-content">
                      <div class="gdlr-core-recent-post-widget-title">
                        <a href="#">{{ dataBerita.title }}</a>
                      </div>
                      <div class="gdlr-core-recent-post-widget-info">
                        <span
                          class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date"
                          ><a href="#">{{ dataBerita.published_at }}</a></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import broker from "@/utils/broker";

export default {
  props: ["meta", "history", "purpose", "gallery", "berita"],
  data() {
    return {
      page: 1,
      limit: 10,
      news: [],
      currentPage: 0,
      lastPage: 0,
      paging: [],
    };
  },
  metaInfo() {
    return {
      title: `${this.meta.name} - Pengumuman`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  async mounted() {
    await this.getData(1);
  },
  methods: {
    async getData(page) {
      await broker.fetch
        .get(
          `/webschool/content?page=${page}&limit=${this.limit}&types[]=information&status=published`
        )
        .then((res) => {
          const data = res.data.data;
          const meta = res.data.meta;
          this.news = data;
          this.currentPage = meta.current_page;
          this.lastPage = meta.last_page;
          this.pageNumbers();
        });
    },
    async goPage(type) {
      let number = 0;
      if (type === "next") {
        number = this.currentPage + 1;
      } else {
        number = this.currentPage - 1;
      }

      await broker.fetch
        .get(
          `/webschool/content?page=${number}&limit=${this.limit}&types[]=information&status=published`
        )
        .then((res) => {
          const data = res.data.data;
          const meta = res.data.meta;
          this.news = data;
          this.currentPage = meta.current_page;
          this.lastPage = meta.last_page;
          this.pageNumbers();
        });
    },
    pageNumbers() {
      var result = [];
      if (this.lastPage - this.currentPage <= 2) {
        // if (this.currentPage > this.lastPage - this.limit) {
        // result.push(this.lastPage - 2, this.lastPage - 1, this.lastPage);
        if (this.lastPage - 2 > 0) result.push(this.lastPage - 2);

        if (this.lastPage - 1 > 0) result.push(this.lastPage - 1);

        if (this.lastPage) result.push(this.lastPage);
      } else {
        result.push(
          this.currentPage,
          this.currentPage + 1,
          this.currentPage + 2,
          "...",
          this.lastPage
        );
      }

      this.paging = result;
    },
  },
};
</script>
